<template>
  <div class="wrapper" v-if="deposits.length !== 0">
    <div>
      <span class="date-title">{{ dateFromCalendar }}</span>
    </div>
    <div class="r-table r-table--5cols r-table--collapse">
      <div class="r-table-row r-table-row--head">
        <div class="r-table-cell name-cell column-heading">Name</div>
        <div class="r-table-cell atm-cell column-heading">AMT</div>
        <div class="r-table-cell dep-hour-cell column-heading">
          DEP. HOUR
        </div>
        <div class="r-table-cell lead-reg-cell column-heading">LEAD REG</div>
        <div class="r-table-cell campaign-cell column-heading">CAMPAIGN</div>
        <div class="r-table-cell continent-cell column-heading">CONTINENT</div>
      </div>
      <div
        class="r-table-row"
        v-for="(deposit, index) in deposits"
        :key="deposit.id"
        :class="{ 'is-striped': index % 2 != 0 }"
      >
        <div class="r-table-cell name-cell">
          <div class="r-table-cell--heading">Date</div>
          <div class="r-table-cell--content date-content">
            {{ deposit.name }}
          </div>
        </div>
        <div class="r-table-cell atm-cell">
          <div class="r-table-cell--content title-content">
            {{ deposit.amount }}
          </div>
        </div>
        <div class="r-table-cell dep-hour-cell">
          <div class="r-table-cell--heading"></div>
          <div class="r-table-cell--content access-link-content">
            {{ deposit.deposit_hour }}
          </div>
        </div>
        <div class="r-table-cell lead-reg-cell">
          <div class="r-table-cell--heading">Replay</div>
          <div class="r-table-cell--content replay-link-content">
            {{ deposit.lead_reg }}
          </div>
        </div>
        <div class="r-table-cell campaign-cell">
          <div class="r-table-cell--heading">Replay</div>
          <div class="r-table-cell--content replay-link-content">
            {{ deposit.campaign }}
          </div>
        </div>
        <div class="r-table-cell r-table-cell--foot continent-cell">
          <div class="r-table-cell--heading">Checklist</div>
          <div class="r-table-cell--content pdf-content">
            {{ deposit.continent }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "@/helpers/api/request";
import moment from "moment";
// import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "DepositsPopup",
  mixins: [UsersPermissionCheck],

  props: {
    dateFromCalendar: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      deposits: []
    };
  },
  created() {
    this.fetchDeposits(this.dateFromCalendar);
  },
  methods: {
    async fetchDeposits(date) {
      if (this.CheckUserPermission([1, 2, 3, 4, 5, 7, 12])) {
        try {
          const res = await apiClientCreator(
            `reports/deposits/specific_deposits`
          ).get("", {
            params: {
              date
            }
          });
          this.deposits = res.data;
        } catch (e) {}
      }
    }
  }
};
</script>

<style scoped lang="scss">
$breakpoint: 750px;
/*$heading-color: #43bac0;*/
$heading-color: #c12fff;

* {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 1em auto;
  padding: 1em;
}

.is-striped {
  /*background-color: rgba(233, 200, 147, 0.2);*/
  background-color: #f8f8f8;
}

/* Table column sizing
================================== */
.name-cell {
  width: 15%;
}
.atm-cell {
  width: 15%;
}
.dep-hour-cell {
  width: 15%;
}
.lead-reg-cell {
  width: 25%;
}
.campaign-cell {
  width: 15%;
}
.continent-cell {
  width: 15%;
}

/* Apply styles
================================== */
.r-table {
  display: flex;
  flex-wrap: wrap;
  /*margin: 0 0 3em 0;*/
  padding: 0;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

  .r-table-row {
    width: 100%;
    display: flex;

    .r-table-cell {
      box-sizing: border-box;
      flex-grow: 1;
      padding: 0.8em 1.2em;
      overflow: hidden; // Or flex might break
      list-style: none;

      &.column-heading {
        background-color: $heading-color;
        color: white;
        padding: 1em;
      }

      .r-table-cell--heading {
        display: none;
      }

      .r-table-cell--content {
        a {
          font-size: 2em;
          color: #333;
        }

        .webinar-date {
          font-weight: 700;
        }
      }
    }
  }
}

/* Responsive
==================================== */
@media all and (max-width: $breakpoint) {
  .is-striped {
    background-color: white;
  }

  .r-table--collapse {
    display: block;
    width: 100%;
    padding: 1em;
    box-shadow: none;

    .r-table-row {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2em;
      box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

      .r-table-cell {
        width: 100% !important;
        display: flex;
        align-items: center;

        .r-table-cell--heading {
          display: inline-block;
          flex: 1;
          max-width: 120px;
          min-width: 120px;
          color: $heading-color;
          font-weight: 700;
          border-right: 1px solid #ccc;
          margin-right: 1em;
        }

        .r-table-cell--content {
          flex: 2;
          padding-left: 1em;
        }
      }
    }

    .atm-cell {
      background-color: $heading-color;
      color: white;
      font-weight: 700;
      order: -1;

      .r-table-cell--content {
        padding-left: 0 !important;
      }
    }

    .r-table-row--head {
      display: none;
    }
  }
}

// Non-Flex modernizer fallback
.no-flexbox .r-table {
  display: block;

  &.r-table-cell {
    width: 100%;
  }
}

.date-title {
  font-size: 14px;
  font-weight: 700;
}
</style>
